module.exports = __webpack_public_path__ + "img/3.872b1ac3.jpg";